export default "__VITE_ASSET__DGau$1cF__"